import { createCRUDHook } from './createCRUDHook';
import { ShipmentDocumentDto } from 'utils/models';
import { TBL_SHIPMENT_DOCUMNET } from './apiEndPoints';

const { Context, useManager, useConsumer } =
  createCRUDHook<ShipmentDocumentDto>({
    entityName: 'ShipmentDocument',
    endpoint: TBL_SHIPMENT_DOCUMNET,
  });

export const ShipmentDocumentContext = Context;
export const useShipmentDocumentManager = useManager;
export const useShipmentDocument = useConsumer;
